export { default } from './VerticalTabsItem';
export * from './VerticalTabsItem.types';
